import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {DashboardState} from '../../../_contracts/DashboardState';
import Translate from '../../../../../components/translate/Translate';
import {requireImage} from '../../../../../utils/utils';

import './styles.scss';

export interface IOneClickGuidanceProps {
    dashboardState: DashboardState;
    isAndroidOrIphone: 'android' | 'apple';
    micFabSlot?: React.ReactNode;
}

@observer
export class OneClickGuidance extends TechseeBaseComponent<IOneClickGuidanceProps> {
    renderInternal(): JSX.Element {
        const isAndroid = this.props.isAndroidOrIphone === 'android';
        const showAudioVariant = this.props.dashboardState.displayAudioButton;
        const deviceImagePath = isAndroid
            ? showAudioVariant
                ? 'wizard/android/one-click-guidance-audio.png'
                : 'wizard/android/one-click-guidance.png'
            : showAudioVariant
              ? 'wizard/iphone/one-click-guidance-audio.png'
              : 'wizard/iphone/one-click-guidance.png';

        return (
            <div className='guidance-container'>
                <div>
                    <div className='margin-bottom-20 guidance-text-one-click'>
                        <Translate text='WIZARD.MAIN.PHOTO' />
                    </div>
                    {this.props.micFabSlot}
                    <img
                        className='img-phone-uploading-image'
                        src={requireImage(deviceImagePath)}
                        alt='one click guidance'
                    />
                </div>
            </div>
        );
    }
}
